<template>
    <div name="healthcare" class="healthcare" id="healthcare">
        <div class="healthcare-title">
            <span class="care-title">누구나 쉽고 편한<br>의료 환경을 만듭니다</span>
            <span class="care-sub-title">의료서비스가 필요한 모든 상황,<br>솔닥의 디지털 헬스케어 솔루션이 함께합니다.</span>
        </div>
        <div class="inner-card">
            <a href="https://soldoc.co.kr/" class="care-card">
                <div class="label-area">
                    <span class="label">진료예약</span>
                    <span class="label">자동결제</span>
                    <span class="label">서류발급</span>
                </div>
                <span class="card-title">바로솔닥</span>
                <span class="sub-text">병원 찾기부터 병원 예약, 결제와<br>서류 발급까지 바로솔닥 앱 하나로<br>간편하게 해결하세요</span>
                <span class="state-area">
					<span class="state state-link">자세히 보기</span>
                </span>
            </a>
            <a href="https://soldoc.co.kr/barocare/" class="care-card" target="_blank" title="새창으로 열림">
                <div class="label-area">
                    <span class="label">시니어케어</span>
                    <span class="label">비대면진료</span>
                </div>
                <span class="card-title">바로돌봄</span>
                <span class="sub-text">주야간보호센터, 요양원, 정신병원 등<br>에서 도입하여 이용할 수 있는 의료 취약<br>계층을 위한 원격 진료 솔루션입니다</span>
                <span class="state-area">
                    <span class="state state-link">자세히 보기</span>
                </span>
            </a>
            <a href="https://soldoc.co.kr/partners" class="care-card" target="_blank" title="새창으로 열림">
                <div class="label-area">
                    <span class="label">제휴병원</span>
                    <span class="label">EMR</span>
                </div>
                <span class="card-title">솔닥파트너스</span>
                <span class="sub-text">솔닥 제휴 의료진에게만 제공되는<br>특별한 혜택을 경험하고 앞서나가는<br>의료 서비스를 제공하세요</span>
                <span class="state-area">
                    <span class="state state-link">자세히 보기</span>
                </span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'healthcare',
    mounted: function()
    {
        $(window).scroll(function () {
            var height = $(document).scrollTop();
            var contTop = $('.healthcare').offset().top;

            var contHeight = height - contTop;
            var winHeight = $(window).height();
            var acviveHeight = contHeight + winHeight;
            
            if(acviveHeight <= 0)
            {
                $('.care-title').css('display', 'none');
                $('.care-sub-title').css('display', 'none');
                $('.care-card').css('display', 'none');
            
            }
            else if(acviveHeight > 100 && acviveHeight <= 200)
            {
                $('.care-title').css('display', 'flex');
                $('.care-sub-title').css('display', 'flex');
                $('.care-card').css('display', 'flex');
            }     
            else
            {
                $('.care-title').css('display', 'flex');
                $('.care-sub-title').css('display', 'flex');
                $('.care-card').css('display', 'flex');
            }     
        })
    },
    methods: {
    }
}
</script>

<style scoped>
    .healthcare {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        min-width: 100%;
        height: 850px;
        padding-top: 160px;
        background: #F3F4F7;
    }
    .healthcare .inner-card {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 1260px;
        height: 343px;
        margin-top: 85px;
    }
    .healthcare .care-card {
        position: relative;
        display: none;
        flex-direction: column;
        justify-content: space-between;
        width: 360px;
        height: 343px;
        margin: 30px;
        padding: 36px 34px 34px;
        border-radius: 12px;
        border: none;
        background: #fff;
        animation: fadeInUp 1.5s;
        text-decoration-line:none;
    }

    .healthcare-title{
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        width: 100%;
    }
    .healthcare .care-title{
        display: none;
        font-family: 'Pretendard';
        font-weight: 600;
        font-size: 44px;
        line-height: 1.4;
        color: #1A1A1A;
        text-align: center;
        z-index: 10;
        animation: fadeInUp 1s;
    }
    .healthcare .care-sub-title{
        display: none;
        margin-top: 30px;
        font-family: 'Pretendard';
        font-weight: 400;
        font-size: 18px;
        line-height: 1.6;
        color: #666;
        text-align: center;
        z-index: 10;
        animation: fadeInUp1 1.5s;
    }

    .healthcare .label-area{
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .healthcare .label{
        display: flex;
        justify-content: center;
        align-items: center;
        height: 32px;
        padding: 0px 13px;
        border-radius: 6px;
        background: #E3ECFF;
        font-family: 'Pretendard';
        font-size: 16px;
        font-weight: 600;
        color: #004EDD;
        text-align: center;
    }
    .healthcare .label+.label{
        margin-left: 6px;
    }

    .card-title{
        margin-top: 20px;
        font-family: 'Pretendard';
        font-size: 28px;
        font-weight: 600;
        color: #000;
    }
    .sub-text{
        margin-top: 20px;
        font-family: 'Pretendard';
        font-size: 18px;
        font-weight: 400;
        color: #111;
        line-height: 1.65;
    }
    .healthcare .state-area{
        margin-top: 30px;
    }
    .healthcare .state{
        font-family: 'Pretendard';
        font-size: 16px;
        font-weight: 400;
        color: #666;
    }
    .healthcare .state.state-link {
        color: #666;
        text-decoration-line: underline;
        text-underline-position: under;
    }
    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }

    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_main/Healthcare.vue